// Configuration de l'API backend
// Détecte automatiquement l'URL selon l'environnement

const getApiUrl = () => {
  // En production, Nginx sert le frontend et proxyfie l'API sur le même domaine.
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || '';
  }

  // Si on est sur localhost, utiliser localhost:8080
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:8080';
  }
  // Sinon, utiliser le même domaine/IP que le frontend
  // Cela permet au téléphone d'accéder au PC via son IP
  return `http://${window.location.hostname}:8080`;
};

export const API_URL = getApiUrl();

console.log('API URL:', API_URL);
